import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

  /* Border-box everywhere: without this, width:100% + padding overflows the
     viewport (Container was rendering 1320px on 1200px max-width, clipping
     the right edge of every page on laptops and phones). */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  @font-face {
    font-family: "Motiva Sans Light";
    src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
    font-style: normal;
  }

  @font-face {
    font-family: "Motiva Sans Bold";
    src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
    font-style: normal;
  }

  body, html, a {
    font-family: 'Manrope', 'Motiva Sans Light', sans-serif;
  }

  body {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    background: #060D1A;
    color: #EDF2FF;
    overflow-x: hidden;
  }

  body::before {
    content: '';
    position: fixed;
    inset: 0;
    background-image: radial-gradient(circle, rgba(30, 48, 80, 0.6) 1px, transparent 1px);
    background-size: 32px 32px;
    pointer-events: none;
    z-index: 0;
  }

  #root {
    position: relative;
    z-index: 1;
  }

  a:hover {
    color: #E8A020;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Fraunces', 'Motiva Sans Bold', Georgia, serif;
    color: #EDF2FF;
    line-height: 1.1;
    margin: 0;
  }

  p {
    color: #6E89AA;
    line-height: 1.7;
    margin: 0;
  }

  a {
    text-decoration: none;
    outline: none;
    color: #E8A020;

    :hover {
      color: #E8A020;
    }
  }

  *:focus {
    outline: none;
  }

  input, textarea {
    border-radius: 4px;
    border: 1px solid #1E3050;
    background: #0C1628;
    color: #EDF2FF;
    transition: all 0.3s ease-in-out;
    outline: none;
    width: 100%;
    padding: 1rem 1.25rem;

    :focus-within {
      background: #132038;
      box-shadow: #E8A020 0px 0px 0px 1px;
    }
  }

`;
